<template>
  <v-container no-gutters class="pa-0">
    <v-row v-for="(entry, index) in notes" :key="index" no-gutters>
      <v-col cols="12">
        <note-widget :type="entry.type" :message="entry.message"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import NoteWidget from './NoteWidget.vue';

export default {
  name: "NotesWidget",
  components: {NoteWidget},
  props: {
    notes: {
      type: Array,
      required: false
    },
  },  
};
</script>